module.exports = __webpack_public_path__ + "img/3f_happiness.4ae2f2ac.svg";